import { STATUS } from '../constants/voucher'

function hasValidVoucher(vouchers) {
  for (let i = 0; i < vouchers.length; i++) {
    if (vouchers[i].status === STATUS.VALID) {
      return true
    }
  }
  return false
}

function reachRequirements(vouchers) {
  if (vouchers.length < 4) return false

  const voucherFor = index => vouchers[index] || {}

  if (voucherFor(3).status === STATUS.VALID || voucherFor(3).status === STATUS.REDEEMED) {
    return true
  }
  return false
}

export function hideRedeemButton({ vouchers }) {
  if (vouchers.length < 4) return true
  return false
}

export function canRedeem({ vouchers }) {
  if (!hasValidVoucher(vouchers)) return false
  return reachRequirements(vouchers)
}

function allRedeemed({ vouchers, count }) {
  if (vouchers.length !== count) return false

  const voucherFor = index => vouchers[index] || {}

  for (let i = 0; i < count; i++) {
    if (voucherFor(i).status !== STATUS.REDEEMED) {
      return false
    }
  }
  return true
}

export function isAllRedeemed({ vouchers }) {
  return allRedeemed({ vouchers, count: 4 })
}
